export default "__VITE_ASSET__BxA1qHMV__"